import { render } from "./pendidikan-list-custom.vue?vue&type=template&id=77150551"
import script from "./pendidikan-list-custom.vue?vue&type=script&lang=js"
export * from "./pendidikan-list-custom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__